import { Plus } from "lucide-react";

const ITEMS = [
  "Caretakers & Attendants",
  "GNM & B.Sc Nurses",
  "Baby Caretaker",
  "Japa Maid",
  "Elder Care",
  "ICU at Home",
];

const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      className="bg-navy py-5 overflow-hidden border-y border-tealbrand/30"
      data-testid="services-marquee"
    >
      <div className="flex w-max animate-marquee items-center">
        {[0, 1].map((copy) => (
          <div key={copy} className="flex items-center shrink-0">
            {row.map((item, i) => (
              <span
                key={`${copy}-${i}`}
                className="flex items-center gap-6 px-6 font-display text-sm sm:text-base font-semibold uppercase tracking-[0.2em] text-slate-300 whitespace-nowrap"
              >
                {item}
                <Plus className="h-4 w-4 text-tealbrand" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
